<div class="PGCalendar {{isLoading ? 'PGCalendar--IsLoading' : ''}} {{isFirstLoading ? 'PGCalendar--IsFirstLoading' : ''}} border rounded">
    @if (isLoading) {
        <div class="PGCalendar-Loading">
            @if (isLoading) {
                <app-pg-loading [isOverlay]="true"></app-pg-loading>
            }
        </div>
    }
    <div class="PGCalendar-Header">
        <div class="PGCalendar-Header-Controls border-bottom">
            <div class="PGCalendar-Header-Controls-Left">
                <!--<button class="btn btn-primary btn-sm me-1" (click)="year = year - 1"><i class="fa-regular fa-angle-double-left"></i></button>-->
                @if (!notAvailable && !isFirstMonth) {
                    <button type="button" class="btn btn-link btn-sm" [disabled]="isLoading" (click)="month = month - 1" [attr.aria-label]="'pg-availability-select.prev-month' | locTranslate">
                        <i class="fa-regular fa-chevron-left" aria-hidden="true"></i>
                    </button>
                }
            </div>
            <div class="PGCalendar-Header-Controls-Center">
                @if (!isFirstLoading) {
                    @if (isFirstMonth) {
                        <h5 class="py-1">{{ 'pg-availability-select.next-availability' | locTranslate }}
                            @if (minDate != null) {
                                {{ 'pg-availability-select.next-availability-from' | locTranslate }} {{localizationService.data.monthNames[month]}} {{year}}
                            }
                        </h5>
                    }
                    @if (!isFirstMonth) {
                        <h5 class="py-1">{{localizationService.data.monthNames[month]}} {{year}}</h5>
                    }
                }
                <!--
                <select [(ngModel)]="month" class="form-control form-control-sm me-1">
                    <option *ngFor="let monthIndex of [0,1,2,3,4,5,6,7,8,9,10,11]" value="{{monthIndex}}">{{localizationService.data.monthNames[monthIndex]}}</option>
                </select>
                <select [(ngModel)]="year" class="form-control form-control-sm">
                    <option *ngFor="let yearOffset of [-5,-4,-3,-2,-1,0,1,2,3,4,5]" value="{{year + yearOffset}}">{{year + yearOffset}}</option>
                </select>
                -->
            </div>
            <div class="PGCalendar-Header-Controls-Right">
                @if (!notAvailable) {
                    <button type="button" class="btn btn-link btn-sm" [disabled]="isLoading" (click)="month = month + 1" [attr.aria-label]="'pg-availability-select.next-month' | locTranslate">
                        <i class="fa-regular fa-chevron-right" aria-hidden="true"></i>
                    </button>
                }
                <!--<button class="btn btn-primary btn-sm ms-1" (click)="year = year + 1"><i class="fa-regular fa-angle-double-right"></i></button>-->
            </div>
        </div>
        <div class="PGCalendar-Header-Days border-bottom">
            @for (day of [0,1,2,3,4,5,6]; track day) {
                <div>
                    {{localizationService.data.dayNames[(day + localizationService.data.weekStart) % 7].substring(0, 3)}}
                </div>
            }
        </div>
    </div>
    @if (notAvailable) {
        <div class="PGCalendar-Content text-muted text-center p-3">
            <h5 class="m-3">{{ 'pg-availability-select.not-available' | locTranslate }}</h5>
        </div>
    }
    @if (!notAvailable && weeks != null) {
        <div class="PGCalendar-Content" role="grid" [attr.aria-label]="'pg-availability-select.next-availability' | locTranslate">
            @for (week of weeks; track week; let i = $index) {
                <div class="PGCalendar-Content-Week" role="row">
                    @for (day of week; track day; let j = $index) {
                        <div class="PGCalendar-Content-Week-Day {{getDayFlagClass(day)}} border {{getBorderClass(i, j)}}"
                            role="gridcell"
                            [attr.tabindex]="day != null ? 0 : -1"
                            [attr.aria-selected]="selectedDay == day || null"
                            [attr.aria-label]="day != null ? (day.date.day + ' ' + localizationService.data.monthNames[day.date.month] + ' ' + day.date.year + (getDayAvailabilityStatusText(day) ? ', ' + getDayAvailabilityStatusText(day) : '')) : null"
                            (click)="setSelectedDay(day)"
                            (keydown.enter)="day != null && setSelectedDay(day)"
                            (keydown.space)="$event.preventDefault(); day != null && setSelectedDay(day)"
                            (mouseenter)="onMouseEnter(day)"
                            (mouseleave)="onMouseLeave(day)">
                            <div class="PGCalendar-Content-Week-Day-Background {{getDayBackgroundClass(day)}}"></div>
                            @if (day != null) {
                                <div class="PGCalendar-Content-Week-Day-Foreground">
                                    <span class="PGCalendar-Content-Week-Day-Title {{getDayTitleClass(day)}}">
                                        @if (mustDayShowMonth(i, j)) {
                                            <b>{{day.date.day}} {{localizationService.data.monthNames[day.date.month].substring(0, 3)}}</b>
                                        }
                                        @if (!mustDayShowMonth(i, j)) {
                                            <span>{{day.date.day}}</span>
                                        }
                                    </span>
                                    <div class="PGCalendar-Content-Week-Day-Events text-muted">
                                        @if (day.elements.length > 0) {
                                            <span>
                                                <div class="PGCalendar-Content-Week-Day-Events-Element">
                                                    @if (getDayAvailabilityStatusText(day); as text;) {
                                                        <span class="PGCalendar-Content-Week-Day-Events-Element-Text">{{text}}</span>
                                                    }
                                                    <span class="bg-{{getDayAvailabilityStatusClass(day)}} PGCalendar-Content-Week-Day-Events-Element-Status" aria-hidden="true"></span>
                                                </div>
                                            </span>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    }
                </div>
            }
        </div>
    }

    @if (selectedDay != null && selectedDay.elements != null && selectedDay.elements.length > 0) {
        <div class="PGCalendar-Detail border" appPgAnimations="Grow;origin:{{getDetailAnimationOrigin()}}">
            <div class="PGCalendar-Detail-Header px-2 border-bottom">
                <span>{{localizationService.data.dayNames[selectedDay.date.weekday]}} {{selectedDay.date.day}} {{localizationService.data.monthNames[selectedDay.date.month]}} {{selectedDay.date.year}}</span>
                <button type="button" class="btn btn-link" (click)="selectedDay = null" [attr.aria-label]="'pg-availability-select.close-detail' | locTranslate">
                    <i class="fa-regular fa-times" aria-hidden="true"></i>
                </button>
            </div>
            <div class="PGCalendar-Detail-Content">
                <div class="m-2">
                    @if (globalTimezone != null && globalTimezone != currentTimezone) {
                        <div class="PGCalendar-Detail-Content-Timezones px-2 m-1 border border-white">
                            <div>
                                <span>{{ 'pg-availability-select.timezone' | locTranslate }} {{globalTimezone}}</span>
                            </div>
                            <div>
                                <span>{{ 'pg-availability-select.timezone' | locTranslate }} {{currentTimezone}}</span>
                            </div>
                            <div class="PGCalendar-Detail-Content-Timezones-Button {{availabilityType == 'product' ? 'PGCalendar-Detail-Content-Timezones-Button--Product' : ''}}">
                            </div>
                        </div>
                    }
                    @for (element of selectedDay.elements; track element) {
                        @if (element.availability != null) {
                            <button [disabled]="isElementUnavailable(element)" class="btn btn-block border mb-2 PGCalendar-Detail-Content-Element {{element == selectedAvailability ? 'btn-primary PGCalendar-Detail-Content-Element--Selected' : isElementUnavailable(element) ? 'btn-light' : ''}}" appPgAnimations="FadeIn" (click)="setSelectedAvailability(element)">
                                <div class="PGCalendar-Detail-Content-Element-Header">
                                    <div class="PGCalendar-Detail-Content-Element-Header-Timespan">
                                        <div>
                                            <div class="PGCalendar-Detail-Content-Element-Header-Timespan-Hours">
                                                <div>
                                                    @if (element.end != null) {
                                                        <span [innerHTML]="'pg-availability-select.time-from-to' | locTranslate:'from':getElementTime(element, 'begin'):'to':getElementTime(element, 'end')"></span>
                                                    }
                                                    @if (element.end == null) {
                                                        <span [innerHTML]="'pg-availability-select.time-at' | locTranslate:'at':getElementTime(element, 'begin')"></span>
                                                    }
                                                    @if (globalTimezone == null && element.timezone != null && element.timezone != currentTimezone) {
                                                        <small class="ms-1">({{ 'pg-availability-select.timezone' | locTranslate }} {{element.timezone}})</small>
                                                    }
                                                </div>
                                                @if (element.timezone != null && element.timezone != currentTimezone) {
                                                    <div>
                                                        @if (element.end != null) {
                                                            <span [innerHTML]="'pg-availability-select.time-from-to' | locTranslate:'from':getElementTime(element, 'begin', true):'to':getElementTime(element, 'end', true)"></span>
                                                        }
                                                        @if (element.end == null) {
                                                            <span [innerHTML]="'pg-availability-select.time-at' | locTranslate:'at':getElementTime(element, 'begin', true)"></span>
                                                        }
                                                    </div>
                                                }
                                            </div>
                                            @if (element.info; as info) {
                                                <div>
                                                    <i class="fa-regular fa-circle-info text-muted me-2"></i>
                                                    <span>{{info}}</span>
                                                </div>
                                            }
                                        </div>
                                        <!--<small class="ms-1 text-muted">id: {{element.id}}</small>-->
                                        <div class="PGCalendar-Detail-Content-Element-Header-Timespan-Button {{availabilityType == 'product' ? 'PGCalendar-Detail-Content-Element-Header-Timespan-Button--Product' : ''}}">
                                            @if (formatCurrentAvailability(element); as formatted) {
                                                <span class="opacity-80">
                                                    {{ 'pg-availability-select.available-slots' | locTranslate:'num':formatted }}
                                                </span>
                                            }
                                            @if (!isElementUnavailable(element)) {
                                                <i class="fa-regular fa-chevron-right"></i>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </button>
                        }
                    }
                </div>
            </div>
            <div class="PGCalendar-Detail-Footer px-2 border-top">
                <div class="PGCalendar-Detail-Footer-Title my-1">
                    <b>{{ 'pg-availability-select.dates-in' | locTranslate:'month':localizationService.data.monthNames[selectedDay.date.month]:'year':selectedDay.date.year }}</b>
                </div>
                <ul class="pagination pagination-sm mb-2">
                    @if (daysWithElementsAroundBefore) {
                        <li class="page-item disabled">
                            <a class="page-link">...</a>
                        </li>
                    }
                    @for (day of daysWithElementsAround; track day) {
                        <li class="page-item {{selectedDay == day ? 'active' : ''}}">
                            <button type="button" class="page-link" (click)="setSelectedDay(day)" [attr.aria-current]="selectedDay == day ? 'date' : null" [attr.aria-label]="day.date.day + ' ' + localizationService.data.monthNames[day.date.month]">
                                <div>{{day.date.day}}</div>
                            </button>
                        </li>
                    }
                    @if (daysWithElementsAroundAfter) {
                        <li class="page-item disabled">
                            <a class="page-link">...</a>
                        </li>
                    }
                </ul>
            </div>
        </div>
    }
</div>
